import { useTranslation } from "react-i18next";

import { Input } from "@fragments";

export default function Message({ configRef }) {
    const { t } = useTranslation("groupModals");

    return (
        <Input.Text
            className="publish-post-message mt-4"
            placeholder={t("publishPost.message.placeholder")}
            value={configRef.current.text}
            onInput={(v) => {
                configRef.current.text = v;
            }}
            label={t("publishPost.message.label")}
            size={500}
            multiline
            emoji
        />
    );
}
